import { ref, shallowRef, onMounted, getCurrentInstance } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

export function useCompaniaFiscalDeportistas() {
    const instance = getCurrentInstance();
    const proxy = instance ? instance.proxy : null;

    const companies = ref([]);
    const selectedCompanyId = ref(null);
    const loading = ref(false);
    const saving = ref(false);
    const error = ref('');
    const settingsError = shallowRef('');

    async function fetchCompanies() {
        loading.value = true;
        error.value = '';
        try {
            const teatroId = store.getters.getTeatroId;
            const res = await store.dispatch(
                config.getVuexAlias('back.teatro.compania-eventos.index'),
                { teatro_id: teatroId, filters: {} }
            );
            companies.value = res.data.data || [];
            const footer = store.getters.getFooter;
            if (footer && footer.bases_teatro_company_id !== undefined) {
                selectedCompanyId.value = footer.bases_teatro_company_id ?? null;
            }
        } catch (e) {
            error.value = e?.response?.data?.message || e?.message || 'Error al cargar compañías';
        } finally {
            loading.value = false;
        }
    }

    async function save() {
        saving.value = true;
        error.value = '';
        settingsError.value = '';
        try {
            const listaId = store.getters.getListaId;
            await store.dispatch(
                config.getVuexAlias('back.lista.editar.manager'),
                {
                    lista_id: listaId,
                    bases_teatro_company_id: selectedCompanyId.value ?? null
                }
            );
            if (proxy && proxy.$toast) {
                proxy.$toast.success('Compañía guardada correctamente');
            }
            try {
                await store.dispatch('SETTINGS');
            } catch (refreshError) {
                settingsError.value = refreshError?.response?.data?.message || refreshError?.message || 'Error al actualizar settings';
                if (proxy && proxy.$toast) {
                    proxy.$toast.warning(settingsError.value);
                }
            }
        } catch (e) {
            error.value = e?.response?.data?.message || e?.message || 'Error al guardar';
            if (proxy && proxy.$toast) {
                proxy.$toast.error(error.value);
            }
        } finally {
            saving.value = false;
        }
    }

    onMounted(fetchCompanies);

    return { companies, selectedCompanyId, loading, saving, error, settingsError, save, fetchCompanies };
}
